// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2yboz","col":"styles_col__1qp4y"};